import Icon16 from 'components/common/Icon16'

export default Icon16
